'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fallback = function Fallback() {
    return _react2.default.createElement('div', { style: { width: '100%', background: '#fff', height: 30 } });
};

exports.default = Fallback;